import cn from "classnames"
import {
  HighestKodemScore,
  HighKodemScore,
  LowKodemScore,
  MediumKodemScore
} from ".."

import styles from "./KodemScoreIcon.module.scss"

export const KodemScoreIcon = ({ score }: { score: number }) => {
  if (score >= 900)
    return <HighestKodemScore className={cn(styles.icon, styles.iconRed)} />

  if (score >= 700)
    return <HighKodemScore className={cn(styles.icon, styles.iconRed)} />

  if (score >= 400)
    return <MediumKodemScore className={cn(styles.icon, styles.iconOrange)} />

  return <LowKodemScore className={cn(styles.icon, styles.iconNeutral)} />
}
